import { Integrators, IntegratorsLabel, Shop } from "@/types/v2";

/**
 * The shop's connected integration display name (e.g. "Tekmetric"), or
 * undefined for a manual-only shop -- callers use the undefined case to hide
 * integration-specific UI (two-way sync affordances, writeback copy) rather
 * than showing it with a "No Integration" label. Mirrors the default in
 * repositories/shop.ts's generateIntegration.
 */
export function getIntegrationName(shop: Shop | undefined): string | undefined {
  if (!shop) return undefined;
  const integration = shop.integration ?? Integrators.tekmetric;
  if (integration === Integrators.manual) return undefined;
  return IntegratorsLabel[integration];
}
